import script from "./createLocationSponsorAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./createLocationSponsorAccount.vue?vue&type=script&setup=true&lang=js"

import "./createLocationSponsorAccount.vue?vue&type=style&index=0&id=72fbb730&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72fbb730"]])

export default __exports__